import { useQueryString } from '@amzn/dots-core-ui';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { CorePage, CorePageTitle } from '$/components';
import { HostsUri } from '$/features/routes';
import { HostForm } from './components';

export type HostQueryParams = {
  hostname: string;
  publicKey: string;
  version: string;
};

export function HostRegisterPage(): JSX.Element {
  const { params } = useQueryString<HostQueryParams>({
    hostname: '',
    publicKey: '',
    version: '',
  });
  const history = useHistory();
  // const { openToast } = useToaster();

  const onSubmit = useCallback(() => {
    // TODO: link with new hams
    console.log('hello');
  }, []);

  return (
    <CorePage
      title="Register Agent"
      breadcrumbs={[{ title: 'Host Agents', href: HostsUri }]}
      header={<CorePageTitle title="Register a New Host Agent" />}
    >
      <HostForm
        onSubmit={onSubmit}
        onCancel={() => history.push(HostsUri)}
        hostname={params.hostname}
        rsapub={params.publicKey}
        version={params.version}
      />
    </CorePage>
  );
}
